<template>
  <Scrollable :style="scrollableStyle">
    <div class="betslip-body-wrapper"
         :style="{'background-image': !activeBetslip ?
       'url(' + require(`../../assets/empty-betslip-${theme}.png`) + ')' : 'none'}"
         :class="{active: activeBetslip}">
       <span class="empty-message">
         {{emptyBetslipMessage | translate}}
       </span>
      <BetslipBet :bettingLocked="bettingLocked"/>
      <BetslipFooter :bettingLocked="bettingLocked"
                     :payinDisabled="payinDisabled"
                     :predefinedStakes="predefinedStakes"/>
    </div>
  </Scrollable>
</template>

<script>
import { mapGetters } from 'vuex';
import BetslipBet from './BetslipBet';
import BetslipFooter from './BetslipFooter';
import Scrollable from '../Scrollable';

export default {
  name: 'BetslipBody',
  components: {
    BetslipBet,
    BetslipFooter,
    Scrollable,
  },
  props: {
    theme: {
      type: String,
      default: 'dark',
    },
    bettingLocked: {
      type: Boolean,
      default: false,
    },
    payinDisabled: {
      type: Boolean,
      default: true,
    },
    predefinedStakes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      emptyBetslipMessage: 'general_ticket_empty_message',
    };
  },
  computed: {
    ...mapGetters([
      'ticket',
    ]),
    activeBetslip() {
      return this.ticket.bets.length > 0;
    },
    scrollableStyle() {
      return {
        height: '100%',
      };
    },
  },
  mounted() {
    this.disabled = this.payinDisabled;
  },
};
</script>

<style lang="scss" scoped>
.betslip-body-wrapper {
  position: relative;
  float: left;
  width: 100%;
  background-color: var(--betslip-bg, var(--bg-color-2));
  background-position: center 25%;
  background-repeat: no-repeat;

  .empty-message {
    position: absolute;
    top: 60%;
    left: 50%;
    color: var(--text-primary-1);
    opacity: 0.3;
    font-size: 1em;
    line-height: 1.38;
    width: 200px;
    text-align: center;
    transform: translate(-50%, 0);
  }

  &.active {
    .empty-message {
      display: none;
    }
  }

  &.disabled {
    opacity: .4;
  }

  ::v-deep {
    .betslip-footer-wrapper {
      position: absolute;
      bottom: 20px;
    }
  }
}

@media (min-width: 306px) and (max-width: 660px) {
  .betslip-body-wrapper {
    height: 100%;

    &.active {
      height: auto;

      ::v-deep {
        .betslip-footer-wrapper {
          position: relative;
        }
      }
    }

    .empty-message {
      top: 65%;
    }
  }
}

@media (min-width: 661px) {
  .betslip-body-wrapper {
    min-height: 271px;
    height: 271px;

    .empty-message {
      top: 70%;
    }

    ::v-deep {
      .betslip-footer-wrapper {
        display: none;
      }
    }
  }
}

@media (min-width: 961px) {
  .betslip-body-wrapper {
    min-height: 352px;
    max-height: 500px;
  }
}
</style>
